import { Map, fromJS } from 'immutable'

import { SET_TYPEAHEAD_RESULTS, SET_TYPEAHEAD_LOADING, INIT_TYPEAHEAD } from '../actions'

export const initialState = new Map({})

const typeaheadReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case INIT_TYPEAHEAD:
      return state.setIn([action.id, 'loading'], false).setIn([action.id, 'results'], [])
    case SET_TYPEAHEAD_RESULTS:
      return state.setIn(
        [action.id],
        fromJS({
          loading: false,
          results: action.data
        })
      )
    case SET_TYPEAHEAD_LOADING:
      return state.setIn([action.id, 'loading'], true)
    default:
      return state
  }
}

export default typeaheadReducer
